/**
 * Sidebar management and navigation
 */

export function initializeSidebar() {
  // Implement delayed sidebar expansion on hover
  const sidebar = document.querySelector('.sidebar');
  let sidebarHoverTimer;
  let sidebarLeaveTimer;

  if (sidebar) {
    // Mouse enter - delay before expanding
    sidebar.addEventListener('mouseenter', () => {
      clearTimeout(sidebarLeaveTimer); // Cancel any pending collapse

      // Set timer for 1 second before expanding
      sidebarHoverTimer = setTimeout(() => {
        sidebar.classList.add('expanded');
      }, 1000); // Delay of 1 second (1000ms)
    });

    // Mouse leave - collapse after slight delay
    sidebar.addEventListener('mouseleave', () => {
      clearTimeout(sidebarHoverTimer); // Cancel any pending expansion

      // Set timer for slight delay before collapsing (for better UX)
      sidebarLeaveTimer = setTimeout(() => {
        sidebar.classList.remove('expanded');
      }, 300); // Small delay of 300ms when leaving
    });
  }

  // Toggle sidebar on mobile
  const sidebarToggle = document.getElementById('sidebar-toggle');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', () => {
      const sidebar = document.querySelector('.sidebar');
      sidebar.classList.toggle('show');
    });
  }

  // Sidebar toggle functionality
  const sidebarToggleBtn = document.querySelector('#sidebarToggle');
  const sidebarElement = document.querySelector('#sidebar');
  if (sidebarToggleBtn && sidebarElement) {
    sidebarToggleBtn.addEventListener('click', () => {
      sidebarElement.classList.toggle('show');
    });
  }
}
